import React from "react";

const NXServerHealth = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_4287_3113)">
        <path
          d="M12.5 0.5H1.5C0.947715 0.5 0.5 0.947715 0.5 1.5V4.5C0.5 5.05228 0.947715 5.5 1.5 5.5H12.5C13.0523 5.5 13.5 5.05228 13.5 4.5V1.5C13.5 0.947715 13.0523 0.5 12.5 0.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7.5 3H11" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M1.5 5.5C1.23478 5.5 0.98043 5.60536 0.792893 5.79289C0.605357 5.98043 0.5 6.23478 0.5 6.5V9.5C0.5 9.76522 0.605357 10.0196 0.792893 10.2071C0.98043 10.3946 1.23478 10.5 1.5 10.5H12.5C12.7652 10.5 13.0196 10.3946 13.2071 10.2071C13.3946 10.0196 13.5 9.76522 13.5 9.5V6.5C13.5 6.23478 13.3946 5.98043 13.2071 5.79289C13.0196 5.60536 12.7652 5.5 12.5 5.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 8.25C3.11193 8.25 3 8.13807 3 8C3 7.86193 3.11193 7.75 3.25 7.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 8.25C3.38807 8.25 3.5 8.13807 3.5 8C3.5 7.86193 3.38807 7.75 3.25 7.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 3.25C3.11193 3.25 3 3.13807 3 3C3 2.86193 3.11193 2.75 3.25 2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 3.25C3.38807 3.25 3.5 3.13807 3.5 3C3.5 2.86193 3.38807 2.75 3.25 2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7.5 8H11" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10.5V13.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 13.5H12" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4287_3113">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NXServerHealth;
